import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useApiManager from '../../utils/Api/apiManager';

const ContactsAutoComplete = ({ setContactId, contactId, shouldFetchSingleContact, small = false, fullWidth = true }) => {
    const [contactOptions, setContactOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const pageSize = 6;
    const { post, get } = useApiManager();

    const fetchAndSetData = async (pageNum, inputText) => {
        try {
            setLoading(true);

            const payload = {
                pageNumber: pageNum,
                pageSize,
                filters: [
                    {
                        fieldName: 'firstName', // Filter field
                        filterOperator: 2, // Example: "contains" operator
                        fieldValue: inputText || '', // Use inputValue for filtering
                        fieldType: 1, // Example: string field type
                    },
                ],
                sortField: '', // Optional: Add sort field if needed
                sortDescending: false, // Optional: Set sorting direction
            };

            const response = await post('/contacts/paged', payload);

            const options = response.items.map(contact => ({
                label: `${contact.firstName} ${contact.lastName}`,
                value: contact.id,
            }));

            setContactOptions(prev =>
                pageNum === 1 ? options : [...prev, ...options] // Reset or append options based on page
            );
            setTotalCount(response.totalCount);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch data when the component mounts or input value changes
    useEffect(() => {
        // if (shouldFetchSingleContact === true) {
        //     return;
        // }
        if (inputValue.length >= 2) {
            fetchAndSetData(1, inputValue); // Fetch with updated input value
        } else if (inputValue === '') {
            fetchAndSetData(1, ''); // Clear filter when input is cleared
        }
    }, [inputValue]);

    // Fetch single contact by ID
    useEffect(() => {
        if (contactId > 0 && shouldFetchSingleContact) {
            const fetchContactById = async () => {
                try {
                    setLoading(true);
                    const response = await get(`/leads/${contactId}`);
                    const contactOption = {
                        label: `${response.firstName} ${response.lastName}`,
                        value: response.id,
                    };

                    // Add the fetched contact to options
                    setContactOptions((prev) => {
                        // Check if the contact already exists in the options
                        const contactExists = prev.some(option => option.value === contactOption.value);

                        // If it doesn't exist, add it; otherwise, return the current options
                        if (!contactExists) {
                            return [contactOption, ...prev];
                        }
                        return prev;
                    });


                    // Set the selected option
                    setSelectedOption(contactOption);
                } catch (error) {
                    console.error('Error fetching contact by ID:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchContactById();
        }
    }, [contactId, shouldFetchSingleContact]);

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        setPageNumber(1);
    };

    const handleScrollToBottom = () => {
        const totalFetched = contactOptions.length;
        if (totalFetched < totalCount && !loading) {
            const nextPage = pageNumber + 1;
            setPageNumber(nextPage);
            fetchAndSetData(nextPage, inputValue);
        }
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: small ? '40px' : '56px',
            height: small ? '40px' : '56px',
            padding: '0px 8px',
            borderRadius: '4px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
            backgroundColor: '#fff',
            borderRadius: '4px',
        }),
    };

    return (
        <div style={{ width: fullWidth ? '100%' : 'auto' }}>
            <Select
                isLoading={loading}
                isClearable
                options={contactOptions}
                value={selectedOption} // Use the explicitly managed selected option
                onChange={(selectedOption) => {
                    setContactId(selectedOption ? selectedOption.value : null);
                    setSelectedOption(selectedOption); // Update the selected option
                }}
                onInputChange={handleInputChange}
                placeholder="Select Contact"
                styles={customStyles}
                maxMenuHeight={200}
                onMenuScrollToBottom={handleScrollToBottom} // Load more data on scroll
                noOptionsMessage={() => (loading ? 'Loading...' : 'No options available')}
            />
        </div>
    );
};
export default ContactsAutoComplete;